<!--
  Reusable report preview component for printing/saving as PDF
-->
<template>
  <v-card
    class="pa-4"
    color="#ffffff"
    :elevation="!$vuetify.breakpoint.xs ? 2 : 0"
  >
    <loading-provider :loading="loading">
      <div
        id="voucher-print-area"
      >
        <v-divider style="margin-bottom: 10px" />
        <div style="font-size: 15px; text-align: left">
          <div>{{ restaurantInfo?.name }}</div>
          <div>{{ restaurantInfo?.adress1 }}</div>
          <div class="d-flex">
            <div class="mr-2">
              {{ restaurantInfo?.postCode }}
            </div>
            <div>{{ restaurantInfo?.city }}</div>
          </div>
          <div>{{ restaurantInfo?.telephone }}</div>
        </div>
        <v-divider style="margin-top: 10px;margin-bottom: 10px" />
        <div style="font-size: 15px; text-align: left">
          <div>
            Gutscheinbericht
          </div>
          <div>
            Vom {{ displayStart }}Bis {{ displayEnd }}
          </div>
          <div>
            Erstellt am: {{ displayNow }}
          </div>
        </div>
        <v-divider style="margin-top: 10px;margin-bottom: 10px" />

        <div style="font-size: 15px; text-align: left">
          <div>
            Verkaufte Gutscheine
          </div>
          <v-simple-table
            style="margin-top: 10px"
            dense
          >
            <thead>
              <tr>
                <th class="text-left">
                  Code
                </th>
                <th class="text-left">
                  Guthaben
                </th>
                <th class="text-left">
                  Gesamtbetrag
                </th>
                <th class="text-left">
                  das Kaufdatum
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in salesInfo"
                :key="item.id"
              >
                <td class="text-left">
                  {{ item.longId }}
                </td>
                <td class="text-left">
                  {{ item.leftAmount }}
                </td>
                <td class="text-left">
                  {{ item.totalAmount }}
                </td>
                <td class="text-left">
                  {{ item.createdAt }}
                </td>
              </tr>
              <tr>
                <td class="text-left font-weight-bold">
                  Total
                </td>
                <td class="text-left font-weight-bold">
                  {{ salesTotalLeftAmount }}
                </td>
                <td class="text-left font-weight-bold">
                  {{ salesTotalAmount }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <v-divider style="margin-top: 10px;margin-bottom: 10px" />

        <div style="font-size: 15px; text-align: left">
          <div>
            Eingelöste Gutscheine
          </div>
          <v-simple-table
            style="margin-top: 10px"
            dense
          >
            <thead>
              <tr>
                <th class="text-left">
                  Code
                </th>
                <th class="text-left">
                  OrderId
                </th>
                <th class="text-left">
                  Gesamtbetrag
                </th>
                <th class="text-left">
                  das Nutzungsdatum
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in usedInfo"
                :key="item.id"
              >
                <td class="text-left">
                  {{ item.memmberCardName }}
                </td>
                <td class="text-left">
                  {{ item.orderId }}
                </td>
                <td class="text-left">
                  {{ item.amount }}
                </td>
                <td class="text-left">
                  {{ item.createdAt }}
                </td>
              </tr>
              <tr>
                <td class="text-left font-weight-bold">
                  Total
                </td>
                <td class="text-left" />
                <td class="text-left font-weight-bold">
                  {{ usedTotalAmount }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <v-divider style="margin-top: 10px;margin-bottom: 10px" />
      </div>
      <div class="footer-actions">
        <v-btn
          width="100%"
          small
          color="primary"
          v-print="'#voucher-print-area'"
        >
          {{ $t('export') }}
        </v-btn>
      </div>
    </loading-provider>
  </v-card>
</template>

<script>

import dayjs from 'dayjs'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'

export default {
  name: 'VoucherReportPreview',
  components: { LoadingProvider },
  props: {
    restaurantInfo: {},
    dateRange: {},
    salesInfo: {},
    usedInfo: {},
    loading: {
      default: false
    }
  },
  data () {
    return {
      exporting: false
    }
  },
  computed: {
    displayStart () {
      return this.dateRange[0]
    },
    displayEnd () {
      return this.dateRange[1]
    },
    displayNow () {
      return dayjs().format('DD.MM.YYYY HH:mm:ss')
    },
    salesTotalAmount () {
      const list = Array.isArray(this.salesInfo) ? this.salesInfo : []
      const total = list.reduce((sum, it) => {
        const v = Number(it?.totalAmount) || 0
        return sum + v
      }, 0)
      return total.toFixed(2)
    },
    salesTotalLeftAmount () {
      const list = Array.isArray(this.salesInfo) ? this.salesInfo : []
      const total = list.reduce((sum, it) => {
        const v = Number(it?.leftAmount) || 0
        return sum + v
      }, 0)
      return total.toFixed(2)
    },
    usedTotalAmount () {
      const list = Array.isArray(this.usedInfo) ? this.usedInfo : []
      const total = list.reduce((sum, it) => {
        const v = Number(it?.amount) || 0
        return sum + v
      }, 0)
      return total.toFixed(2)
    }
  },
  methods: {
  }
}
</script>

<style scoped>
#voucher-print-area {
  position: relative;
  padding-bottom: 64px; /* space for fixed footer button */
}

.footer-actions {
  position: sticky;
  bottom: 0;
  background: #ffffff;
  z-index: 1000;
  padding-top: 8px;
  padding-bottom: 8px;
}

@media (max-width: 600px) {
  #voucher-print-area {
    padding-bottom: 72px;
  }
}

/* Keep normal flow when printing/PDF to avoid overlap */
@media print {
  .footer-actions {
    position: static !important;
  }
}
</style>
